import { ChatApi } from './chat-api';
import { CloudApi, CloudApiTransport } from './cloud-api';

const cloudApiTransport = new CloudApiTransport();
export const cloudApi = new CloudApi(cloudApiTransport);

export const chatApi = new ChatApi();
